import React from "react";
import { Container, Row,Col } from "react-bootstrap";
function Footer() {
  return (
    <footer class="footer__info" id="footer">
      <Container>
        <Row>
          <div class="col-12">
            <div class="footer__title d-flex">
              Удобная площадка для безопасной покупки или продажи групп и
              каналов в социальных сетях ВКонтакте, Telegram, Одноклассники,
              Facebook, Instagram,TikTok,YouTube.
            </div>
            <div class="footer__subtitle">
              Биржа групп в социальных сетях, которая поможет вам быстро продать
              или купить группу ВКонтакте, Одноклассники, Instagram, Facebook,
              Telegram. С услугой "Безопасная сделка" вы можете купить группу
              или аккаунт в любой соц.сети без риска нарваться на мошенников.
              Смотрите новые объявления о продаже групп каждый день или
              подпишитесь на объявления соответствующие вашим запросам и
              получайте актуальную информацию на электронную почту. У нас самые
              низкие цены на качественные группы!
            </div>
            <div class="footerlk__icons d-flex">
              <div class="footerlk__icon">
                <div class="sm__item psi4">
                  <a href="#">
                    <i class="fab fa-vk"></i>
                  </a>
                </div>
              </div>

              <div class="footerlk__icon">
                <div class="sm__item psi5">
                  <a href="#">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
              <div class="footerlk__icon">
                <div class="sm__item psi8">
                  <a href="#">
                    <i class="fab fa-telegram-plane"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="footerlk__more d-flex">
              <div class="footer-more__item">
                Главная
                <div class="footer-more_abs"></div>
              </div>
              <div class="footer-more__item">
                Информация
                <div class="footer-more_abs"></div>
              </div>
              <div class="footer-more__item">Сервис</div>
            </div>
            <div class="footershk">© Redslon.com, 2020</div>
          </div>
          </Row>
        </Container>
    </footer>
  );
}

export default Footer;
